import { createSlice } from '@reduxjs/toolkit';
import ReducerRegistry from '../redux/ReducerRegistry';
// Initial state
const initialState = {
    isLocked: false
};
// Create a slice for poll moderation
const lockRoom = createSlice({
    name: 'features/lock-room',
    initialState,
    reducers: {
        activeLockRoom: (state) => {
            state.isLocked = true;
        },
        unActiveLockRoom: (state) => {
            state.isLocked = false;
        },
    }
});
// Register reducer
ReducerRegistry.register('features/lock-room', lockRoom.reducer);
export const { activeLockRoom, unActiveLockRoom } = lockRoom.actions;
export default lockRoom.reducer;
